<template>
	<Multiselect
		v-bind="forwardedAttrs"
		:model-value="resolvedValue"
		@update:model-value="onUpdate"
	>
		<template v-for="(_, name) in $slots" #[name]="slotData">
			<slot :name="name" v-bind="slotData || {}" />
		</template>
	</Multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

/**
 * Bridges Vue 2-style v-model (value + input) used across the app
 * with vue-multiselect@3 (modelValue + update:modelValue).
 *
 * COMPONENT_V_MODEL: false so parent `v-model` binds to modelValue /
 * update:modelValue (Vue 3). We still emit `input` for legacy `@input`
 * side-effect listeners. Order matters: model updates first, then `input`,
 * so `v-model` + `@input="handler"` sees fresh local state (Vue 2 behavior).
 */
export default {
	name: "OvMultiselect",
	components: { Multiselect },
	inheritAttrs: false,
	// Keep listeners in $attrs (Vue 3) so @search-change / @open / etc. forward via v-bind.
	compatConfig: {
		INSTANCE_LISTENERS: false,
		COMPONENT_V_MODEL: false,
	},
	props: {
		modelValue: {},
		value: {},
	},
	emits: ["update:modelValue", "input"],
	computed: {
		resolvedValue() {
			return this.modelValue !== undefined ? this.modelValue : this.value;
		},
		forwardedAttrs() {
			const attrs = { ...this.$attrs };
			// Avoid leaking legacy Vue 2 v-model bindings onto the inner component.
			delete attrs.value;
			delete attrs.onInput;
			return attrs;
		},
	},
	methods: {
		onUpdate(val) {
			this.$emit("update:modelValue", val);
			this.$emit("input", val);
		},
	},
};
</script>
